// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/positive-g-effects.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/positive-g-effects/positive-g-effects.js';

mount([g0]);
